import { render, staticRenderFns } from "./SpellCreator.vue?vue&type=template&id=5bd56a05&scoped=true&"
import script from "./SpellCreator.vue?vue&type=script&lang=js&"
export * from "./SpellCreator.vue?vue&type=script&lang=js&"
import style0 from "./SpellCreator.vue?vue&type=style&index=0&id=5bd56a05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd56a05",
  null
  
)

export default component.exports